import { bodyComposition } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { SelectionContainer } from '../../Bookings/components/SelectionContainer';
import Theme, { ThemeType } from '../../theme';
import { i18n } from '../../utils';
import { defaultScale, scaleText } from '../../utils/scaling';

import EctoShape from '../../assets/images/bodytype-images/ecto.svg';
import EctomesoShape from '../../assets/images/bodytype-images/ectomeso.svg';
import EndoShape from '../../assets/images/bodytype-images/endo.svg';
import EndomesoShape from '../../assets/images/bodytype-images/endomeso.svg';
import MesoShape from '../../assets/images/bodytype-images/meso.svg';
interface IProps {
    composition: bodyComposition | null;
    onPress(composition: bodyComposition): Promise<void>;
}

export const mappedBodyTypes = {
    [bodyComposition[bodyComposition.meso]]: {
        title: i18n.t('bodyscan:meso'),
        image: (color = Theme.BLACK, hight= 25, width = 25) =>
            <MesoShape width={width} hight={hight} color={color} />,
    },
    [bodyComposition[bodyComposition.ecto]]: {
        title: i18n.t('bodyscan:ecto'),
        image: (color = Theme.BLACK, hight= 25, width = 25) =>
        <EctoShape width={width} hight={hight} color={color} />,
    },
    [bodyComposition[bodyComposition.endo]]: {
        title: i18n.t('bodyscan:endo'),
        image: (color = Theme.BLACK, hight= 25, width = 25) =>
        <EndoShape width={width} hight={hight} color={color}/>,
    },
    [bodyComposition[bodyComposition.ecto_meso]]: {
        title: i18n.t('bodyscan:ecto_meso_short'),
        image: (color = Theme.BLACK, hight= 25, width = 25) =>
        <EctomesoShape width={width} hight={hight} color={color}/>,
    },
    [bodyComposition[bodyComposition.endo_meso]]: {
        title: i18n.t('bodyscan:endo_meso_short'),
        image: (color = Theme.BLACK, hight= 25, width = 25) =>
        <EndomesoShape width={width} hight={hight} color={color}/>,
    },
};

export const BodyscaleBodyTypeSelector: FunctionComponent<IProps> =
    ({ onPress, composition }) => {
        return (
            <View style={styles.wrapedContainer}>
                <BodyType
                    onPress={onPress}
                    currentComposition={composition}
                    composition={bodyComposition[bodyComposition.ecto]}
                />
                <BodyType
                    onPress={onPress}
                    currentComposition={composition}
                    composition={bodyComposition[bodyComposition.meso]}
                />
                <BodyType
                    onPress={onPress}
                    currentComposition={composition}
                    composition={bodyComposition[bodyComposition.endo]}
                />
                <BodyType
                    onPress={onPress}
                    currentComposition={composition}
                    composition={bodyComposition[bodyComposition.ecto_meso]}
                />
                <BodyType
                    onPress={onPress}
                    currentComposition={composition}
                    composition={bodyComposition[bodyComposition.endo_meso]}
                />
            </View>
        );
    };

const BodyType = ({ currentComposition, composition, onPress }) => {
    const isSelected = currentComposition === composition;
    const selectedIconColor = isSelected ? Theme.WHITE : Theme.BLACK;
    return (
            <SelectionContainer
                width={defaultScale(85)}
                height={defaultScale(89)}
                style={styles.selectionContainer}
                title={mappedBodyTypes[composition].title}
                titleStyle={styles.title}
                isSelected={isSelected}
                onPress={() => onPress(composition)}
                theme={ThemeType.light}
                icon={mappedBodyTypes[composition].image(selectedIconColor)}
            />
    );
};

const styles = StyleSheet.create({
    wrapedContainer: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: defaultScale(20),
    },
    title: {
        fontSize: scaleText(13),
        fontFamily: Theme.Weight700,
    },
    selectionContainer: {
        margin: 5,
    },
});
